import { Directive, effect, input, model, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { SelectionCardInterface } from './selection-card.interface';

@Directive()
export abstract class SelectionCardBase implements OnInit {
	customFormControl = input<FormControl>(new FormControl());
	grid = input<'cols-1' | 'cols-2' | 'cols-3'>('cols-2');
	hasCardsAsMarkdown = input<boolean>(false);
	hasError = input<boolean>(false);
	isDisabled = input<boolean>(false);
	isReadonly = input<boolean>(false);
	isValid = input<boolean>(false);
	name = input<string>('');
	options = model<SelectionCardInterface[]>([]);

	abstract readonly cardControlType: 'radio' | 'checkbox';

	constructor() {
		let isFirstRun = true;
		effect(() => {
			const currentIsValid = this.isValid();

			// Skip initial effect run to avoid clearing pre-selected options on init
			if (isFirstRun) {
				isFirstRun = false;
				return;
			}

			// If invalid, set all options to not selected
			if (!currentIsValid) {
				this.options.update((options) => {
					return options.map((option) => {
						return {
							...option,
							selected: false,
						};
					});
				});

				this.updateFormControl();
			}
		});
	}

	ngOnInit() {
		this.updateFormControl();
	}

	abstract updateOptions(element: string): void;
	protected abstract updateFormControl(): void;
}
